import { Component, OnInit, HostBinding, Input, Output, EventEmitter, OnDestroy, ViewChild, AfterViewInit, ChangeDetectionStrategy, ElementRef } from '@angular/core';
import { Observable, of, Subscription, Subject, zip } from 'rxjs';
import { map, shareReplay, tap, bufferCount, delay } from 'rxjs/operators';
import { Problem as ProblemModel } from '../header/menu/menu.component';
import { Subject as SubjectModel } from '../header/subjects/subject/subject.model';
import { SwiperConfigInterface, SwiperDirective } from 'ngx-swiper-wrapper';
import { SliderService } from '../slider.service';
import { MillionService } from '../million.service';
import { ApiService, Problem } from '../api.service';
import { UIStateService } from '../ui-state.service';

@Component({
  selector: 'mea-playground',
  templateUrl: './playground.component.html',
  styleUrls: ['./playground.component.css'],
  // changeDetection: ChangeDetectionStrategy.OnPush // millionare-answer 5050 bug
})
export class PlaygroundComponent implements OnInit, OnDestroy, AfterViewInit {
  @Output() selected: EventEmitter<any> = new EventEmitter();
  @Output() score: EventEmitter<number> = new EventEmitter<number>();
  @Input() game?: '1vs1' | 'million' | undefined;
  @Input() type: 'math' | 'text';
  @Input() activity: 'practice' | 'test' | 'finalTest' | 'million' | '1vs1';
  @Input() topic: { name: string, hierarchy: string };
  @Input() path: { name: string, hierarchy: string, __typename?: string }[] = [];
  @Input() topics?: { name: string, hierarchy: string }[];
  scoreSubscription: Subscription;
  // @HostBinding('class') private class = 'playground';

  /*
  @HostBinding('class.playground--ingame') private get ingameCss() {
    return this.game !== undefined;
  }
  */

  private querySubscription: Subscription;
  loading$: Observable<boolean>;
  error$: Observable<readonly any[]>;
  quiz$: Observable<any>;

  public problems: ProblemModel[];
  public problems$: Observable<ProblemModel[]>;
  subjects$: Observable<SubjectModel[]>;
  current = 0;
  length = 1;
  inReview = false;
  rightAnswers = new Subject<boolean>();
  // public score: Observable<number>;

  public config: SwiperConfigInterface = {
    allowTouchMove: false,
    shortSwipes: false,
    longSwipes: false,
    direction: 'horizontal',
    slidesPerView: 1,
    navigation: true,
    pagination: true
  };

  // TODO update menu with current problem
  @ViewChild('ourslider', { static: false }) set ourslider(ourslider: ElementRef) {
    if (ourslider && ourslider.nativeElement) {
      this.sliderService.register(ourslider.nativeElement, this.length);
    }
  }

  @ViewChild(SwiperDirective, { static: false }) set slider(slider: SwiperDirective) {
    if (slider) {
      //slider.config.allowTouchMove = false;
      // Solves expression changes during initialization
      this.sliderService.register(slider, this.length);
    }
  }
  constructor(
    private apiService: ApiService,
    public sliderService: SliderService,
    private millionService: MillionService,
    private uiState: UIStateService
  ) { }

  ngAfterViewInit() {
    /*setTimeout(() => {
      debugger;
      let el = this.ourslider.nativeElement;
      el.scrollLeft = el.scrollLeft - el.clientWidth;
    }, 2500);*/
    /*this.quiz$.subscribe(_problems => {
      if (_problems) {
        this.sliderService.register(this._slider, this.length);
      }
    });*/
  }
  ngOnInit() {
    if (!this.topic && !this.topics) { return; }

    this.uiState.setActivity(this.activity);
    this.uiState.setType(this.type);

    this.config.allowTouchMove = (this.activity !== 'million');

    this.path = this.path || [];
    const MATH_HIERARCHY = '03';
    let hierarchy;
    if (this.topic) {
      hierarchy = this.topic.hierarchy;
      this.path.push({ ...this.topic });
    } else if (this.topics) {
      hierarchy = this.topics[0];
      this.path.push({ name: 'מגוון נושאים', hierarchy });
    }
    this.type = (hierarchy.startsWith(MATH_HIERARCHY)) ? 'math' : 'text';
    if (this.path.length > 3) {
      this.path.shift();
    } else if (this.path.length < 3) {
      this.path.push({ name: '', hierarchy: '' });
    }
    this.uiState.setSubjectList(this.path.map(t => ({ name: t.name, hierarchy: t.hierarchy })));

    const source$ = this.getQuiz();
    this.loading$ = source$.pipe(map(result => result.loading));
    this.error$ = source$.pipe(map(result => result.errors));
    this.quiz$ = source$.pipe(map(result => result.data));

    /*this.querySubscription = this.quiz$.subscribe(_problems => {
      this.problems = _problems;
      if (this.problems) {
        this.length = this.problems.length;
        this.currentProblemChanged(0);
      }
    });*/
    this.problems$ = this.quiz$.pipe(tap(_problems => {
      this.problems = _problems;
      if (this.problems) {
        this.length = this.problems.length;
        // this.currentProblemChanged(0); // for clue-solution

        this.sliderService.reset(this.length);
        this.sliderService.current.subscribe({next: (currentId) => {
          this.currentProblemChanged(currentId);
        }});

        this.scoreSubscription = this.rightAnswers.pipe(bufferCount(_problems.length)).pipe(map((rightAnswers) => {
          const totalCount = rightAnswers.length;
          const correctCount = rightAnswers.filter(correct => correct).length;
          const score = Math.round(100 * correctCount / totalCount);

          this.uiState.setScore(score);

          // this.score.emit();
        })).subscribe();

      }
    })); // .pipe(map<Subject[], Problem[]>(_problems => _problems));
    /*this.subjects$ = this.quiz$.pipe(map<Subject[], SubjectModel[]>(subjectList => {
      let result: SubjectModel[] = [];
      let subject = subjectList[0];
      result.push({ name: subject.name, hierarchy: subject.hierarchy });
      subject = subject.parent;
      if (subject) {
        result.push({ name: subject.name, hierarchy: subject.hierarchy });
        subject = subject.parent;
        if (subject) {
          result.push({ name: subject.name, hierarchy: subject.hierarchy });
        }
      }
      result = result.reverse();
      return result;
    }));*/
  }

  getQuiz(): Observable<{ loading: boolean; errors: any[]; data: ProblemModel[] }> {
    let hierarchies: string[];
    if (this.topic) {
      hierarchies = [this.topic.hierarchy];
    } else if (this.topics) {
      hierarchies = this.topics.map(t => typeof t === 'string' ? t : t.hierarchy);
    }

    const hierarchyToIds = (h: string) => {
      return this.apiService.getSubjectProblems(h);
    };

    function shuffle<T>(a: T[]) {
      let j: number; let x: T; let i: number;
      for (i = a.length - 1; i > 0; i--) {
        j = Math.floor(Math.random() * (i + 1));
        x = a[i];
        a[i] = a[j];
        a[j] = x;
      }
      return a;
    }

    return zip(...hierarchies.map(h => hierarchyToIds(h)))
      .pipe(map((arraiesOfIds: { id: number }[][]) => {
        // Only shuffle for non-practice activities to keep practice order stable
        if (this.activity === 'practice') {
          return arraiesOfIds;
        }
        return arraiesOfIds.map(shuffle);
      }))
      .pipe(map((arraiesOfIds: { id: number }[][]) => {
        let howMany: number;
        switch (this.activity) {
          case 'test': howMany = 3; break;
          case 'finalTest': howMany = 5; break;
          case 'million': howMany = (14 + 1); break; // million + change question
          case '1vs1': howMany = 6; break;
          case 'practice': howMany = arraiesOfIds[0].length; break;
        }

        const fromEach = Math.min(1, howMany / arraiesOfIds.length);
        const result: { id: number }[] = [];
        for (const ids of arraiesOfIds) {
          result.push(...ids.slice(0, fromEach));
        }
        const left = howMany - result.length;
        result.push(...arraiesOfIds[0].slice(fromEach, fromEach + left));

        // Only shuffle for non-practice activities
        if (this.activity !== 'practice') {
          shuffle(result);
        }

        return result;
      }))
      .pipe(
        map(ids => ids.map(o => o.id)),
        // Fetch problems by IDs
        map(cleanIds => {
          const inTest = ['test', 'finalTest'].indexOf(this.activity) > -1;
          return { cleanIds, inTest };
        })
      )
      .pipe(
        // Convert to the format expected by the component
        map(({ cleanIds, inTest }) => {
          // Return an observable that fetches problems
          return this.apiService.getProblemsByIds(cleanIds, inTest).pipe(
            map(problems => ({
              loading: false,
              errors: [],
              data: problems.map(p => ({
                id: p.id,
                question: p.question,
                correct: p.correct,
                wrong2: p.wrong2,
                wrong3: p.wrong3,
                wrong4: p.wrong4,
                difficulty: p.difficulty,
                subject: p.subject,
              } as unknown as ProblemModel))
            }))
          );
        }),
        // Flatten the nested observable
        map(obs => obs),
        // Use switchMap equivalent
        (source) => new Observable(subscriber => {
          let innerSub: Subscription;
          const outerSub = source.subscribe({
            next: (innerObs) => {
              if (innerSub) innerSub.unsubscribe();
              innerSub = innerObs.subscribe({
                next: val => subscriber.next(val),
                error: err => subscriber.error(err),
              });
            },
            error: err => subscriber.error(err),
            complete: () => {
              // Don't complete until inner completes
            }
          });
          return () => {
            outerSub.unsubscribe();
            if (innerSub) innerSub.unsubscribe();
          };
        })
      )
      .pipe(shareReplay(1)) as Observable<{ loading: boolean; errors: any[]; data: ProblemModel[] }>;
  }

  ngOnDestroy() {
    this.sliderService.unregister();
    if (this.scoreSubscription) { this.scoreSubscription.unsubscribe(); }
    return this.querySubscription && this.querySubscription.unsubscribe();
  }

  currentProblemChanged(index) {
    setTimeout(() => {
      if (this.problems && this.problems[index]) {
        this.uiState.setCurrentProblemId(this.problems[index].id as unknown as number);
      }
    }, 0);
  }

  onReview(wasCorrect) {
    if (wasCorrect === undefined) {
      return;
    }
    this.rightAnswers.next(wasCorrect);
  }

  onAnswerChosen(answer: { id: number, correct: boolean }) {
    if (this.activity === 'million') {
      if (answer.correct) {
        of(0).pipe(delay(1500), map(() => {
          this.sliderService.nextSlide();
          this.millionService.advance();
        })).subscribe();
      } else {
        this.millionService.gameover();
      }
    }
    this.selected.emit(answer);
  }

  times(n: number) {
    if (!Number.isInteger(n)) { n = 5; }
    return new Array(n);
  }
}
